export default __webpack_public_path__ + "static/800-826b63d42b9f9a8bb1659e75d02b5e1f.gif";